import { React } from 'Imports';
import { VideoEventCommentResponse } from '$Generated/api';
import { Comment } from './Comment';
import { Divider } from 'MaterialUIComponents';
import { IUserManagementServiceInjectedProps, UserManagementService } from '$State/UserManagementFreezerService';

interface CommentListBaseProps {
    comments: VideoEventCommentResponse[];
    onEdit: (comment: VideoEventCommentResponse) => void;
    accessToComment?: boolean;
}

type CommentListProps = CommentListBaseProps & IUserManagementServiceInjectedProps;

const styles = require('./EventComments.scss') as {
    commentListDivider: string;
    noComments: string;
};

const _CommentList = (props: CommentListProps) => {
    const currentUserId = UserManagementService.getCurrentUserId();
    return props.comments.length === 0 ? (
        <div className={styles.noComments}>No comments</div>
    ) : (
        <div>
            {props.comments
                .slice()
                .sort((a, b) => new Date(b.createdOn!).getTime() - new Date(a.createdOn!).getTime())
                .map((comment, index) => (
                    <span key={comment.id}>
                        <Comment
                            eventComment={comment}
                            editable={props.accessToComment && comment.createdById === currentUserId}
                            onEdit={props.onEdit}
                        />
                        {index < props.comments.length - 1 && <Divider className={styles.commentListDivider} />}
                    </span>
                ))}
        </div>
    );
};

export const CommentList = UserManagementService.inject(_CommentList);
